import React, { useState } from 'react';
import { Edit2, Info, HeartPulse, Sparkles, ChevronDown, ChevronUp, CreditCard } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';
const pulseScoreData = [{
  month: 'Apr',
  score: 82,
  isKeyEvent: false
}, {
  month: 'May',
  score: 85,
  isKeyEvent: false
}, {
  month: 'Jun',
  score: 88,
  isKeyEvent: false
}, {
  month: 'Jul',
  score: 90,
  event: 'Financial statement filed: Revenue up 15% YoY',
  isKeyEvent: true
}, {
  month: 'Aug',
  score: 87,
  isKeyEvent: false
}, {
  month: 'Sep',
  score: 89,
  event: 'UCC filing: New equipment financing secured',
  isKeyEvent: true
}, {
  month: 'Oct',
  score: 91,
  event: 'News: International expansion announced',
  isKeyEvent: true
}, {
  month: 'Nov',
  score: 88,
  isKeyEvent: false
}, {
  month: 'Dec',
  score: 92,
  event: 'Financial statement: Record Q4 revenue',
  isKeyEvent: true
}, {
  month: 'Jan',
  score: 88,
  event: 'People: Charlie Bucket promoted to Factory Manager',
  isKeyEvent: true
}, {
  month: 'Feb',
  score: 89,
  event: 'DBT improved from 8 to 5 days',
  isKeyEvent: true
}, {
  month: 'Mar',
  score: 88,
  isKeyEvent: false
}];
const healthScoreData = [{
  month: 'Apr',
  score: 90
}, {
  month: 'May',
  score: 91
}, {
  month: 'Jun',
  score: 92
}, {
  month: 'Jul',
  score: 93,
  event: 'Financial statement: Strong revenue growth',
  isKeyEvent: true
}, {
  month: 'Aug',
  score: 92
}, {
  month: 'Sep',
  score: 93,
  event: 'Financial statement: Z-Score improved to 4.2',
  isKeyEvent: true
}, {
  month: 'Oct',
  score: 94
}, {
  month: 'Nov',
  score: 93
}, {
  month: 'Dec',
  score: 94
}, {
  month: 'Jan',
  score: 95,
  event: 'Financial statement: Debt-to-equity ratio at 0.4x',
  isKeyEvent: true
}, {
  month: 'Feb',
  score: 94
}, {
  month: 'Mar',
  score: 94
}];
const paymentScoreData = [{
  month: 'Apr',
  score: 85
}, {
  month: 'May',
  score: 86
}, {
  month: 'Jun',
  score: 87
}, {
  month: 'Jul',
  score: 88
}, {
  month: 'Aug',
  score: 87
}, {
  month: 'Sep',
  score: 88
}, {
  month: 'Oct',
  score: 89,
  event: 'DBT decreased from 8 to 5 days (37.5% improvement)',
  isKeyEvent: true
}, {
  month: 'Nov',
  score: 90
}, {
  month: 'Dec',
  score: 89
}, {
  month: 'Jan',
  score: 90
}, {
  month: 'Feb',
  score: 91,
  event: 'Trade data: 6 months perfect payment record',
  isKeyEvent: true
}, {
  month: 'Mar',
  score: 90
}];
function PositiveIndicator() {
  return <div className="flex items-end gap-0.5 shrink-0 mt-1" data-id="element-4114" data-mp="3kvjrq8ddebhv">
      <div className="w-1 h-1.5 bg-green-500 rounded-sm" data-id="element-4115" data-mp="20eu70ghb8ojb" />
      <div className="w-1 h-2.5 bg-green-500 rounded-sm" data-id="element-4116" data-mp="20d9c2pr333kx" />
      <div className="w-1 h-3.5 bg-green-500 rounded-sm" data-id="element-4117" data-mp="255kblrhwwncy" />
    </div>;
}
function NegativeIndicator() {
  return <div className="flex items-end gap-0.5 shrink-0 mt-1" data-id="element-4118" data-mp="1qhfq6frh5xqh">
      <div className="w-1 h-1.5 bg-red-500 rounded-sm" data-id="element-4119" data-mp="1vfhbz8gacb5n" />
      <div className="w-1 h-2.5 bg-red-500 rounded-sm" data-id="element-4120" data-mp="1vg0pmcywkddv" />
      <div className="w-1 h-3.5 bg-red-500 rounded-sm" data-id="element-4121" data-mp="2j4k1t3l2pab8" />
    </div>;
}
function ScoreTooltip({
  active,
  payload,
  label,
  color
}: any) {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const dotColor = data.score !== undefined ? getDotColor(data.score) : color;
    return <div className="bg-white rounded-lg border border-gray-200 shadow-lg px-4 py-3 max-w-[250px]" data-id="element-4122" data-mp="2e57e6gmdnz7l">
        <div className="flex items-center justify-between mb-2" data-id="element-4123" data-mp="yo5k7buaoqya">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4124" data-mp="12qtuzp2kk7xw">
            {label}
          </p>
          <div className="flex items-center gap-1.5" data-id="element-4125" data-mp="1iygjyjpqnive">
            <div className="w-2 h-2 rounded-full" style={{
            backgroundColor: dotColor
          }} data-id="element-4126" data-mp="1j01bs1ko4npk" />
            <span className="text-sm font-bold text-gray-900" data-id="element-4127" data-mp="1996nysrrxg20">
              {payload[0].value}
            </span>
          </div>
        </div>
        {data.event && <p className="text-sm text-gray-700 leading-snug border-t border-gray-100 pt-2 mt-1" data-id="element-4128" data-mp="21wkdw6x21bcm">
            {data.event}
          </p>}
      </div>;
  }
  return null;
}
function getDotColor(score: number) {
  if (score <= 30) return '#ef4444';
  if (score <= 70) return '#eab308';
  return '#22c55e';
}
const CustomDot = (props: any) => {
  const {
    cx,
    cy,
    payload
  } = props;
  const color = getDotColor(payload.score);
  if (payload.isKeyEvent) {
    return <g data-id="element-4129" data-mp="ghdah933n8oi">
        <circle cx={cx} cy={cy} r={12} fill={color} fillOpacity={0.2} className="animate-pulse" data-id="element-4130" data-mp="gh4ydjesw7ed" />
        <circle cx={cx} cy={cy} r={6} fill="#ffffff" stroke={color} strokeWidth={3} data-id="element-4131" data-mp="2o6svha2hhwkq" />
      </g>;
  }
  return <circle cx={cx} cy={cy} r={3} fill={color} stroke={color} strokeWidth={2} data-id="element-4132" data-mp="2x4uzzzlff7cr" />;
};
const CustomActiveDot = (props: any) => {
  const {
    cx,
    cy,
    payload
  } = props;
  const color = getDotColor(payload.score);
  return <circle cx={cx} cy={cy} r={8} fill={color} stroke="#fff" strokeWidth={2} data-id="element-4133" data-mp="36v7hfixy2keo" />;
};
export function WonkaOverviewTab() {
  const [healthExpanded, setHealthExpanded] = useState(true);
  const [paymentExpanded, setPaymentExpanded] = useState(true);
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-4134" data-mp="3kw0fgdngfxmj">
      {/* Top Row */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-4135" data-mp="1lj65g703bvpg">
        {/* Credit Settings */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 lg:col-span-1" data-id="element-4136" data-mp="1qgo3v3ghesj7">
          <div className="flex justify-between items-center mb-6" data-id="element-4137" data-mp="2trlfx4u4cyg0">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-4138" data-mp="2tu7wftyzmoad">Credit Settings</h3>
            <button className="w-8 h-8 bg-indigo-600 hover:bg-indigo-700 rounded-full flex items-center justify-center text-white transition-colors" data-id="element-4139" data-mp="2ovd686yoxxg8">
              <Edit2 className="w-4 h-4" data-id="element-4140" data-mp="2xtp50w9po1jr" />
            </button>
          </div>
          <div className="grid grid-cols-2 gap-y-3 gap-x-4" data-id="element-4141" data-mp="3cqzey16pgzdd">
            <div data-id="element-4142" data-mp="3cpel6ds7tkgk">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4143" data-mp="3cowfyrnkrvwi">
                Credit Limit
              </p>
              <p className="text-sm text-gray-600" data-id="element-4144" data-mp="3ljb2nfafq8pn">$100,000</p>
            </div>
            <div data-id="element-4145" data-mp="3lldqpts11rrq">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4146" data-mp="3hi7qp3vicwtp">
                Recommended Limit
              </p>
              <p className="text-sm text-gray-600" data-id="element-4147" data-mp="3vis8pxtlmom5">$100,000</p>
            </div>
            <div data-id="element-4148" data-mp="3qj5ubl21b2br">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4149" data-mp="3qjp2ia1vuccl">
                Outstanding Balance
              </p>
              <p className="text-sm text-gray-600" data-id="element-4150" data-mp="dztciwlq9po2">$28,750</p>
            </div>
            <div data-id="element-4151" data-mp="iwtjraubcygr">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4152" data-mp="ixd2uuvp9swd">
                AP Contact
              </p>
              <p className="text-sm text-gray-600" data-id="element-4153" data-mp="43874a5sqcjp">Grandpa Joe</p>
            </div>
            <div data-id="element-4154" data-mp="8y413fulf9zg">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4155" data-mp="91rw6jfos4ga">
                Terms
              </p>
              <p className="text-sm text-gray-600" data-id="element-4156" data-mp="3w4obd8a2tum9">Net 30</p>
            </div>
            <div data-id="element-4157" data-mp="1d7rb7fe98k">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4158" data-mp="3hfs5nhvhstot">
                Purchasing Contact
              </p>
              <p className="text-sm text-gray-600" data-id="element-4159" data-mp="3me20frdb1s9w">Charlie Bucket</p>
            </div>
            <div data-id="element-4160" data-mp="38ek5eu9f1is3">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4161" data-mp="38g50ckzn73qh">
                Late Pay Penalty
              </p>
              <p className="text-sm text-gray-600" data-id="element-4162" data-mp="3cg5s17br5bfh">1.5%</p>
            </div>
            <div data-id="element-4163" data-mp="3sv53it5t8yig">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4164" data-mp="3svobpi5ns8ja">
                Company Officer
              </p>
              <p className="text-sm text-gray-600" data-id="element-4165" data-mp="3nv0kavdippoj">Willy Wonka</p>
            </div>
            <div data-id="element-4166" data-mp="3iw5tp79b6wtv">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4167" data-mp="3iztosauejrap">
                Date Last Approved
              </p>
              <p className="text-sm text-gray-600" data-id="element-4168" data-mp="39x2ck8tpcri0">1/10/2026</p>
            </div>
            <div data-id="element-4169" data-mp="356lwegyhyrry">
              <p className="text-sm font-semibold text-gray-900 mb-0.5" data-id="element-4170" data-mp="3562dawx41xcc">
                Group
              </p>
              <p className="text-sm text-gray-600" data-id="element-4171" data-mp="306pt6jxmj4dg">Food & Beverage</p>
            </div>
          </div>
        </div>

        {/* Pulse Score */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 lg:col-span-2 flex flex-col" data-id="element-4172" data-mp="2va90rdje63uk">
          <div className="flex items-center gap-2 mb-4" data-id="element-4173" data-mp="2qb5yg0usqbqa">
            <h3 className="text-xl font-bold text-gray-900" data-id="element-4174" data-mp="2m915z5g33l58">Pulse Score</h3>
          </div>
          <div className="flex gap-6 mb-6" data-id="element-4175" data-mp="11onp06n72xo9">
            <div className="bg-green-100 rounded-lg p-4 flex flex-col items-center justify-center min-w-[120px] shrink-0" data-id="element-4176" data-mp="11rs3bwudj9sn">
              <span className="text-4xl font-bold text-gray-900" data-id="element-4177" data-mp="1aqn7l3duy9tb">88</span>
              <span className="text-sm font-medium text-gray-800 mt-1" data-id="element-4178" data-mp="1aoaub3j1onml">
                Low Risk
              </span>
            </div>
            <p className="text-gray-600 text-base leading-relaxed pt-2" data-id="element-4179" data-mp="i2849e439fxt">
              Pulse Score of 88 indicates low risk. Score has remained
              consistently strong over the past year, driven by innovative
              product launches and excellent financial management.
            </p>
          </div>
          <div className="flex-1 min-h-[200px] relative" data-id="element-4180" data-mp="wrnsong5d9ac">
            <div className="absolute top-0 right-0 flex items-center gap-2 text-xs text-gray-500 z-10" data-id="element-4181" data-mp="3vgmcf3zlw2rp">
              <div className="w-3 h-3 bg-black rounded-sm" data-id="element-4182" data-mp="4abdbde5pc30"></div>
              Pulse Score
            </div>
            <ResponsiveContainer width="100%" height="100%" data-id="element-4183" data-mp="3k0j6zn105ntx">
              <LineChart data={pulseScoreData} margin={{
              top: 20,
              right: 10,
              left: -20,
              bottom: 10
            }} data-id="element-4184" data-mp="3k2dkig9y2dnz">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-4185" data-mp="2spa5pjxyy6l" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#6B7280'
              }} dy={10} data-id="element-4186" data-mp="317ot6wf481ra" />
                <YAxis domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#6B7280'
              }} data-id="element-4187" data-mp="3g00edqracdqo" />
                <Tooltip content={<ScoreTooltip data-id="element-4189" data-mp="10l5dn9zfrpkr" />} cursor={{
                stroke: '#E5E7EB',
                strokeWidth: 2,
                strokeDasharray: '4 4'
              }} data-id="element-4188" data-mp="14l611k4ijb3y" />
                <ReferenceLine y={70} stroke="#22c55e" strokeDasharray="4 4" data-id="element-4190" data-mp="qmfu7crw5x2e" />
                <ReferenceLine y={30} stroke="#ef4444" strokeDasharray="4 4" data-id="element-4191" data-mp="loxv0e3oew7l" />
                <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={<CustomDot data-id="element-4193" data-mp="cwm8327rtqwd" />} activeDot={<CustomActiveDot data-id="element-4194" data-mp="7x9ii9pim5q3" />} data-id="element-4192" data-mp="gxpjncisd0rs" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Health Score */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-4195" data-mp="2zr8sh3obmh1">
        <button onClick={() => setHealthExpanded(!healthExpanded)} className="w-full p-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors border-b border-gray-100" data-id="element-4196" data-mp="3u6ap2bsa44mq">
          <div className="flex items-center gap-3" data-id="element-4197" data-mp="3bg706so77yq8">
            <HeartPulse className="w-5 h-5 text-gray-700" data-id="element-4198" data-mp="3bhi5wy17fgjz" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-4199" data-mp="3fgzei0bxgttd">Health Score</h3>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full border-2 border-green-500 bg-white ml-2" data-id="element-4200" data-mp="71pb8owaxik0">
              <div className="w-2.5 h-2.5 rounded-full bg-green-500" data-id="element-4201" data-mp="c1bouzg1l0tc"></div>
              <span className="text-base font-bold text-gray-900" data-id="element-4202" data-mp="3uerpqgafyw1r">94</span>
            </div>
            <Sparkles className="w-4 h-4 text-indigo-400 ml-1 animate-sparkle cursor-pointer" title="Ask Pulse AI about this score" data-id="element-4203" data-mp="3ucyrnpdw9k5d" />
          </div>
        </button>

        {healthExpanded && <div className="p-5" data-id="element-4204" data-mp="urjoh7kj994s">
            <p className="text-base text-gray-600 mb-6" data-id="element-4205" data-mp="usurv6a2gevd">
              WONKA INDUSTRIES has a 0.3% probability of insolvency or
              bankruptcy in the next 12 months.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-4206" data-mp="2ahua1edfkid2">
              {/* Negative Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-4207" data-mp="2p6yteyvyosmr">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-4208" data-mp="2k9gkv9luwffa">
                  Negative Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-4209" data-mp="1rjrjuw95cfdo">
                  <div className="flex items-start gap-2" data-id="element-4210" data-mp="1rl1k9s3h1znh">
                    <NegativeIndicator data-id="element-4211" data-mp="26gqyh42f18hn" />
                    <span className="text-sm text-gray-600" data-id="element-4212" data-mp="26hsb3cz2y31h">
                      High R&D costs for new product development
                    </span>
                  </div>
                </div>
              </div>

              {/* Positive Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-4213" data-mp="3cxcrb6189lp9">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-4214" data-mp="3cz723risbxfm">
                  Positive Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-4215" data-mp="1rg3k0avl2yc9">
                  <div className="flex items-start gap-2" data-id="element-4216" data-mp="1rgwunmxny7zo">
                    <PositiveIndicator data-id="element-4217" data-mp="1vfvx90vx9sny" />
                    <span className="text-sm text-gray-600" data-id="element-4218" data-mp="1vj06wds5pgm0">
                      Strong revenue growth (15% YoY) and excellent Z-Score
                      (4.2)
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-4219" data-mp="2adob7oltm901">
                    <PositiveIndicator data-id="element-4220" data-mp="2ac3gnyziaq26" />
                    <span className="text-sm text-gray-600" data-id="element-4221" data-mp="2f4wm6p2su2fb">
                      52 years in business with global distribution
                    </span>
                  </div>
                </div>
              </div>

              {/* Chart */}
              <div className="lg:col-span-2 h-[200px]" data-id="element-4222" data-mp="2o6w2ff5zp2h7">
                <ResponsiveContainer width="100%" height="100%" data-id="element-4223" data-mp="2t3w8vr6r478u">
                  <LineChart data={healthScoreData} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-4224" data-mp="2t2bb7sp5486r">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-4225" data-mp="2taoqhknf1ypq" />
                    <XAxis dataKey="month" hide data-id="element-4226" data-mp="3lxsqtcbkdov6" />
                    <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#6B7280'
                }} data-id="element-4227" data-mp="3m0on6w7rk5hi" />
                    <Tooltip content={<ScoreTooltip color="#22c55e" data-id="element-4229" data-mp="8l8u8a5fhhsp" />} data-id="element-4228" data-mp="8kr29ppstpql" />
                    <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={<CustomDot data-id="element-4231" data-mp="22zwf9nwmgs08" />} activeDot={<CustomActiveDot data-id="element-4232" data-mp="22zmq22jeiovl" />} data-id="element-4230" data-mp="3spjrm21f2s4" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>}
      </div>

      {/* Payment Score */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-4233" data-mp="1t804pddcn9f4">
        <button onClick={() => setPaymentExpanded(!paymentExpanded)} className="w-full p-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors border-b border-gray-100" data-id="element-4234" data-mp="1fcod3euhpz2f">
          <div className="flex items-center gap-3" data-id="element-4235" data-mp="1ab8ojct3tafa">
            <CreditCard className="w-5 h-5 text-gray-700" data-id="element-4236" data-mp="1ac0jqmish651" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-4237" data-mp="2zpwzd9m1qkb7">Payment Score</h3>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full border-2 border-green-500 bg-white ml-2" data-id="element-4238" data-mp="34pjifzok2urx">
              <div className="w-2.5 h-2.5 rounded-full bg-green-500" data-id="element-4239" data-mp="t1myw3jtg4pw"></div>
              <span className="text-base font-bold text-gray-900" data-id="element-4240" data-mp="o33c60xeeowh">90</span>
            </div>
            <Sparkles className="w-4 h-4 text-indigo-400 ml-1 animate-sparkle cursor-pointer" title="Ask Pulse AI about this score" data-id="element-4241" data-mp="o18pah2kgmpr" />
          </div>
        </button>

        {paymentExpanded && <div className="p-5" data-id="element-4242" data-mp="1brw9o1to54t7">
            <p className="text-base text-gray-600 mb-6" data-id="element-4243" data-mp="1br32x0upmfb2">
              WONKA INDUSTRIES has a 2.1% probability of late payment,
              indicating very low risk.
            </p>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-4244" data-mp="1lpiu13tqlokk">
              {/* Negative Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-4245" data-mp="1gsa9iwl498g5">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-4246" data-mp="3nhf4ea464sdr">
                  Negative Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-4247" data-mp="3ilggsoqnzeee">
                  <div className="flex items-start gap-2" data-id="element-4248" data-mp="2wowv79b6tj93">
                    <span className="text-sm text-gray-600 italic" data-id="element-4249" data-mp="31p1awx49u9y9">
                      No significant negative factors
                    </span>
                  </div>
                </div>
              </div>

              {/* Positive Factors */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-4250" data-mp="3bdjajb0teb0b">
                <h4 className="text-sm font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100" data-id="element-4251" data-mp="2drvlxcalowzc">
                  Positive Impact Factors
                </h4>
                <div className="space-y-3" data-id="element-4252" data-mp="2is03l5n8vxr5">
                  <div className="flex items-start gap-2" data-id="element-4253" data-mp="2no8eu7ybn6t1">
                    <PositiveIndicator data-id="element-4254" data-mp="2socw407205kb" />
                    <span className="text-sm text-gray-600" data-id="element-4255" data-mp="2spe764o2ks21">
                      Perfect payment record with DBT well below industry
                      average
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-4256" data-mp="7wkj2fv1nkbt">
                    <PositiveIndicator data-id="element-4257" data-mp="1sgo9npyz7ymk" />
                    <span className="text-sm text-gray-600" data-id="element-4258" data-mp="1sfmyllhync4u">
                      Strong cash reserves and liquidity
                    </span>
                  </div>
                </div>
              </div>

              {/* Chart */}
              <div className="lg:col-span-2 h-[200px]" data-id="element-4259" data-mp="1dr9zwgrhnf6n">
                <ResponsiveContainer width="100%" height="100%" data-id="element-4260" data-mp="1dqgxtt3h5duu">
                  <LineChart data={paymentScoreData} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-4261" data-mp="18sp0gjk28zj9">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-4262" data-mp="use7naz6xavg" />
                    <XAxis dataKey="month" hide data-id="element-4263" data-mp="2u3fl4v5no8y9" />
                    <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#6B7280'
                }} data-id="element-4264" data-mp="2p65puyvl532i" />
                    <Tooltip content={<ScoreTooltip color="#22c55e" data-id="element-4266" data-mp="32bvhsteel5hh" />} data-id="element-4265" data-mp="378c4dj5yfbsg" />
                    <Line type="monotone" dataKey="score" stroke="#000000" strokeWidth={2} dot={<CustomDot data-id="element-4268" data-mp="2ta4dnszih6pq" />} activeDot={<CustomActiveDot data-id="element-4269" data-mp="2obugxdy51y20" />} data-id="element-4267" data-mp="32b2hob9y9e8b" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}